class Toast {
    constructor() {
        this.container = null;
        this.init();
    }

    /**
     * Initializes toast container in DOM
     */
    init() {
        if (!document.getElementById('toast-container')) {
            this.container = document.createElement('div');
            this.container.id = 'toast-container';
            this.container.className = 'toast-container';
            document.body.appendChild(this.container);
        } else {
            this.container = document.getElementById('toast-container');
        }
    }

    /**
     * Shows toast notification
     * @param {string} message - Toast message text
     * @param {string} type - Toast type: 'success', 'error', 'warning', 'info' (default: 'info')
     * @param {number} duration - Auto-close duration in ms (default: 5000, 0 = no auto-close)
     * @returns {HTMLElement} Toast DOM element
     */
    show(message, type = 'info', duration = 5000) {
        const toast = document.createElement('div');
        toast.className = `toast toast-${type} rounded-2 py-2 px-3`;
        let icon = '';
        switch (type) {
            case 'success':
                icon = '<i class="bi bi-check-circle-fill"></i>';
                break;
            case 'error':
                icon = '<i class="bi bi-x-circle-fill"></i>';
                break;
            case 'warning':
                icon = '<i class="bi bi-exclamation-triangle-fill"></i>';
                break;
            case 'info':
            default:
                icon = '<i class="bi bi-info-circle-fill"></i>';
                break;
        }

        toast.innerHTML = `
            <div class="toast-content d-flex align-items-center gap-2 flex-1">
                <span class="toast-icon">${icon}</span>
                <span class="toast-message">${message}</span>
            </div>
            <button class="toast-close rounded-1 d-flex align-items-center justify-content-center p-1" aria-label="Close">
                <i class="bi bi-x"></i>
            </button>
        `;

        this.container.appendChild(toast);
        requestAnimationFrame(() => {
            toast.classList.add('toast-show');
        });

        const closeButton = toast.querySelector('.toast-close');
        const closeToast = () => {
            this.remove(toast);
        };
        closeButton.addEventListener('click', closeToast);

        if (duration > 0) {
            setTimeout(() => {
                this.remove(toast);
            }, duration);
        }

        return toast;
    }

    /**
     * Removes toast with animation
     * @param {HTMLElement} toast - Toast DOM element to remove
     */
    remove(toast) {
        toast.classList.remove('toast-show');
        toast.classList.add('toast-hide');
        
        setTimeout(() => {
            if (toast.parentNode) {
                toast.parentNode.removeChild(toast);
            }
        }, 300);
    }

    /**
     * Shows success toast
     * @param {string} message - Toast message
     * @param {number} duration - Auto-close duration in ms (default: 5000)
     * @returns {HTMLElement} Toast DOM element
     */
    success(message, duration = 5000) {
        return this.show(message, 'success', duration);
    }

    /**
     * Shows error toast
     * @param {string} message - Toast message
     * @param {number} duration - Auto-close duration in ms (default: 5000)
     * @returns {HTMLElement} Toast DOM element
     */
    error(message, duration = 5000) {
        return this.show(message, 'error', duration);
    }

    /**
     * Shows warning toast
     * @param {string} message - Toast message
     * @param {number} duration - Auto-close duration in ms (default: 5000)
     * @returns {HTMLElement} Toast DOM element
     */
    warning(message, duration = 5000) {
        return this.show(message, 'warning', duration);
    }

    /**
     * Shows info toast
     * @param {string} message - Toast message
     * @param {number} duration - Auto-close duration in ms (default: 5000)
     * @returns {HTMLElement} Toast DOM element
     */
    info(message, duration = 5000) {
        return this.show(message, 'info', duration);
    }
}

const toast = new Toast();
export default toast;

